module.exports = __webpack_public_path__ + "img/DSC_1130.fef61905.jpg";